import { Control, Controller } from "react-hook-form";

import Input from "@/components/Atoms/InputsV2/ToggleInput";
import ErrorUI from "@/components/Atoms/InputsV2/ErrorUI";

import { classNameGenerator } from "@/utils";

import styles from "./ToggleInput.module.scss";

interface ToggleInputProps {
  name: string;
  control: Control<any>;
  className?: string;
  onBlur?: (e: any) => void;
}

const ToggleInput: React.FC<ToggleInputProps> = ({
  name,
  control,
  onBlur = () => {},
  ...rest
}) => {
  const cls = classNameGenerator(styles);

  return (
    <div className={cls("toggleInput")}>
      <Controller
        name={name}
        control={control}
        shouldUnregister
        render={({
          field: { value, onBlur: handleBlur, onChange, ref },
          fieldState: { error },
        }) => (
          <>
            <Input
              ref={ref}
              name={name}
              value={value}
              onChange={onChange}
              onBlur={(e) => {
                handleBlur();
                onBlur(e);
              }}
              {...rest}
            />
            <ErrorUI error={error?.message} />
          </>
        )}
      />
    </div>
  );
};

export default ToggleInput;
